import { getValidDayjs } from "@/utils/safeParse/getValidDayjs"

/** API hotel có thể trả `YYYY-MM-DD` hoặc `YYYYMMDD`. */
export function normalizeHotelApiDate(value: string | undefined | null): string {
  if (!value) {
    return ""
  }
  const trimmed = `${value}`.trim()
  if (/^\d{8}$/.test(trimmed)) {
    return `${trimmed.slice(0, 4)}-${trimmed.slice(4, 6)}-${trimmed.slice(6, 8)}`
  }
  const parsed = getValidDayjs(trimmed)
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : trimmed
}
